import React from 'react';
import css from './Checkbox.module.scss';
import classnames from 'classnames';
import { svgSprite } from '../../../../../hybrid/wrappers';

const Checkbox = ({ isActive, isDisabled }) => {
    return (
        <div
            className={classnames(
                css.formCheckbox,
                isActive ? css.formCheckboxActive : '',
                isDisabled ? css.formCheckboxDisabled : ''
            )}
        >
            {isActive &&
                svgSprite('check', {
                    fill: 'var(--whiteColor)',
                    className: css.formCheckboxSvg
                })}
        </div>
    );
};

export default Checkbox;
